import { useRef, useState } from 'react'
import clsx from 'clsx'

import { Button, CloseButton, Input, useOnClickOutside } from '@pepper/ui'

import s from './ShareReport.module.css'

type Props = {
  link: string
  onClose: () => void
  className?: string
}

const COPY_DELAY = 3000

const ShareReport = ({ onClose, link, className }: Props) => {
  const [isCopied, setIsCopied] = useState(false)

  const copy = async () => {
    await navigator.clipboard.writeText(link)
    setIsCopied(true)

    // to set button to default state
    setTimeout(() => {
      setIsCopied(false)
    }, COPY_DELAY)
  }

  const wrapperRef = useRef<HTMLDivElement>(null)

  useOnClickOutside(wrapperRef, () => {
    onClose()
  })

  return (
    <div ref={wrapperRef} className={clsx(className, s.wrapper)}>
      <div className={s.title}>Share gap analysis report</div>
      <div className={s.description}>
        Now you can copy the link to share this report with anyone you want! The
        report will open in view only mode and will be visible to all
      </div>
      <div className={s.linkWrapper}>
        <p className={s.label}>Sharing link</p>
        <div className={s.link}>
          <Input readOnly={true} value={link} />
          <Button
            type={isCopied ? 'ghost' : 'primary'}
            disabled={isCopied}
            onClick={copy}
          >
            {isCopied ? 'Copied!' : 'Copy'}
          </Button>
        </div>
      </div>
      <span className={s.close}>
        <CloseButton onClose={onClose} />
      </span>
    </div>
  )
}

export default ShareReport
